<template>
	<div class="benefit-order-summary">
		<div class="summary-heading">
			<div>
				<span class="heading-icon"><i class="el-icon-s-order"></i></span>
				<div>
					<strong>订单商品信息</strong>
					<small>订单关联商品及权益概览</small>
				</div>
			</div>
			<slot name="extra"></slot>
		</div>

		<div class="summary-content">
			<div class="summary-fields">
				<div>
					<span>订单号</span>
					<strong>{{ order.orderNo }}</strong>
				</div>
				<div>
					<span>下单时间</span>
					<strong>{{ order.orderTime }}</strong>
				</div>
				<div>
					<span>发货时间</span>
					<strong>{{ order.shipmentTime }}</strong>
				</div>
				<div class="benefit-count">
					<span>功能权益</span>
					<strong>
						<em>{{ order.benefitCount }}</em>
						项
					</strong>
				</div>
			</div>

			<div class="summary-products">
				<div class="products-label">商品明细</div>
				<div class="product-list">
					<div v-for="product in order.products" :key="product.id" class="summary-product">
						<span class="product-icon"><i class="el-icon-s-goods"></i></span>
						<div class="product-info">
							<strong>{{ product.productName }}</strong>
							<p>{{ product.productDesc }}</p>
						</div>
						<span class="product-quantity">× {{ product.quantity }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'BenefitOrderSummary',
		props: {
			order: {
				type: Object,
				required: true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.benefit-order-summary {
		overflow: hidden;
		border: 1px solid #dfe7f0;
		border-radius: 8px;
		background: #fff;
		box-shadow: 0 5px 18px rgba(38, 78, 120, 0.05);
	}

	.summary-heading {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px 20px;
		border-bottom: 1px solid #e8edf2;
		background: linear-gradient(90deg, #f5f9fe, #fff);

		> div:first-child {
			display: flex;
			align-items: center;
		}

		.heading-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 38px;
			height: 38px;
			margin-right: 11px;
			border-radius: 8px;
			color: #2671cb;
			font-size: 19px;
			background: #e3f0fd;
		}

		strong,
		small {
			display: block;
		}

		strong {
			color: #334154;
			font-size: 17px;
		}

		small {
			margin-top: 3px;
			color: #9aa4b1;
			font-size: 14px;
		}
	}

	.summary-content {
		padding: 20px;
		overflow: hidden;
	}

	.summary-fields {
		display: grid;
		grid-template-columns: 1.25fr 1fr 1fr 0.7fr;
		gap: 18px 24px;
		padding-bottom: 18px;
		border-bottom: 1px dashed #dbe3ec;

		span,
		strong {
			display: block;
		}

		span {
			margin-bottom: 7px;
			color: #929ba8;
			font-size: 14px;
		}

		strong {
			color: #3b4859;
			font-size: 14px;
		}

		.benefit-count em {
			color: #e98a24;
			font-size: 20px;
			font-style: normal;
		}
	}

	.summary-products {
		display: flex;
		align-items: flex-start;
		padding-top: 18px;
		overflow: hidden;

		.products-label {
			width: 82px;
			padding-top: 18px;
			color: #7e8998;
			font-size: 14px;
			flex: 0 0 82px;
		}
	}

	.product-list {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
		min-width: 0;
		flex: 1;
	}

	.summary-product {
		display: flex;
		align-items: center;
		min-width: 0;
		padding: 12px 14px;
		overflow: hidden;
		border: 1px solid #e4eaf1;
		border-radius: 7px;
		background: #f8fafc;
		box-sizing: border-box;

		.product-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 60px;
			height: 60px;
			margin-right: 14px;
			border-radius: 11px;
			color: #2773ca;
			font-size: 28px;
			background: linear-gradient(135deg, #eaf4ff, #d8eafd);
			flex: 0 0 60px;
		}

		strong {
			color: #303b4b;
			font-size: 16px;
		}

		p {
			margin: 7px 0 0;
			color: #8b96a4;
			font-size: 14px;
			line-height: 20px;
		}

		.product-info {
			min-width: 0;
			flex: 1;
		}

		.product-quantity {
			margin-left: 12px;
			color: #526277;
			font-size: 14px;
			font-weight: 600;
			white-space: nowrap;
		}
	}
</style>
